let HandleGoBack = {
  data: function () {
    return {
      response: {
        errors: null,
        message: null,
      }
    };
  },
  methods: {
    goBack: function () {
      if (this.returnUrl) {
        window.location.href = this.returnUrl;
        return;
      }

      const prevRouteName = this.$store.getters['router/getPrevName'];
      const currentRouteName = this.$router.history
        && this.$router.history.current
        && this.$router.history.current.name;

      if (prevRouteName === null) {
        if (['payment', 'payment-coins'].includes(currentRouteName)) {
          this.$router.push('/members');
          return;
        }
      }

      if (['last_chance', 'payment-success', 'payment-abort'].includes(prevRouteName)) {
        this.$router.push('/members');
      } else {
        this.$router.back();
      }
    }
  },
};

export default HandleGoBack;
